// extracted by mini-css-extract-plugin
module.exports = {"aside-wrap":"_9e1425b4d3--aside-wrap--K7WjP","journal__bottom-line_mobile":"_9e1425b4d3--journal__bottom-line_mobile--n1npB"};